import * as i0 from '@angular/core';
import { input, inject, ElementRef, computed, Directive } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgDocHighlighterService } from '@ng-doc/app/services';
let NgDocCodeHighlighterDirective = /*#__PURE__*/(() => {
  class NgDocCodeHighlighterDirective {
    constructor() {
      this.code = input.required({
        alias: 'ngDocHighlighter'
      });
      this.element = inject(ElementRef).nativeElement;
      this.highlighter = inject(NgDocHighlighterService);
      this.sanitizer = inject(DomSanitizer);
      this.highlightedCode = computed(() => this.sanitizer.bypassSecurityTrustHtml(this.highlighter.highlight(this.code())));
    }
    static {
      this.ɵfac = function NgDocCodeHighlighterDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocCodeHighlighterDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgDocCodeHighlighterDirective,
        selectors: [["", "ngDocHighlighter", ""]],
        hostVars: 1,
        hostBindings: function NgDocCodeHighlighterDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵhostProperty("innerHTML", ctx.highlightedCode(), i0.ɵɵsanitizeHtml);
          }
        },
        inputs: {
          code: [1, "ngDocHighlighter", "code"]
        },
        standalone: true
      });
    }
  }
  return NgDocCodeHighlighterDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocCodeHighlighterDirective };
